// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__3dVQE","list":"styles_list__24GJw"};